import { render, staticRenderFns } from "./googleAccount.vue?vue&type=template&id=66a02b97&scoped=true&"
import script from "./googleAccount.vue?vue&type=script&lang=js&"
export * from "./googleAccount.vue?vue&type=script&lang=js&"
import style0 from "./googleAccount.vue?vue&type=style&index=0&id=66a02b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a02b97",
  null
  
)

export default component.exports